export interface SaasPage {
  display_name: string;
  url: string;
}

export enum ActionTypes {
  SET_SAAS_PAGES = "SAAS_INTEGRATION_SET_PAGES",
  SET_FIRST_TIME_TOKEN = "SAAS_INTEGRATION_SET_TOKEN",
  SET_LOADING = "SAAS_INTEGRATION_SET_LOADING",
  SET_ERROR = "SAAS_INTEGRATION_SET_ERROR",
  CLEAR_TOKEN = "SAAS_INTEGRATION_CLEAR_TOKEN",
}

export interface State {
  pages: SaasPage[];
  firstTimeToken: string | null;
  tokenExpiry: number | null;
  loading: boolean;
  error: string | null;
}

export type SetSaasPagesAction = {
  type: ActionTypes.SET_SAAS_PAGES;
  pages: SaasPage[];
};

export type SetFirstTimeTokenAction = {
  type: ActionTypes.SET_FIRST_TIME_TOKEN;
  token: string;
  expiry: number;
};

export type SetLoadingAction = {
  type: ActionTypes.SET_LOADING;
  loading: boolean;
};

export type SetErrorAction = {
  type: ActionTypes.SET_ERROR;
  error: string;
};

export type ClearTokenAction = {
  type: ActionTypes.CLEAR_TOKEN;
};

export type SaasIntegrationAction =
  | SetSaasPagesAction
  | SetFirstTimeTokenAction
  | SetLoadingAction
  | SetErrorAction
  | ClearTokenAction;
